<template>
  <div class="allbox">
    <div style="margin-bottom:20px;">
      <div class="condition">
        <el-input
          v-model="query.campaignFeedId"
          class="inptw"
          placeholder="请输入计划id"
        />
        <el-input
          v-model="query.campaignFeedName"
          class="inptw"
          placeholder="请输入计划名称"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
        >搜索</el-button>
        <el-button
          type="primary"
          @click="syncCampaignFeed"
        >同步信息流计划</el-button>
      </div>
    </div>
    <el-table
      :data="baidudataList"
      highlight-current-row
      border
      style="width: 100%"
    >
      <el-table-column
        prop="campaignFeedId"
        label="信息流计划id"
        width="120px"
      />
      <el-table-column
        label="子账号编号/名称"
        width="210px"
      >
        <template slot-scope="scope">
          <el-tag class="tag_box">{{ scope.row.sub_uc_id }}</el-tag>
          <el-tag class="tag_box" type="success">{{ scope.row.sub_uc_name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="campaignFeedName"
        label=" 信息流计划名称"
        width="250px"
      />
      <el-table-column
        label="oCPC信息"
        width="150px"
      >
        <template slot-scope="scope">
          <el-button style="margin-left: 16px;" type="text" @click="openoCPC(scope.row.ocpc)">查看oCPC信息</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="APP信息"
        width="150px"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="appInfoLook(scope.row.appinfo)">查看app详情信息</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="subjectText"
        label="营销目标"
        width="80px"
      />
      <el-table-column
        prop="pauseText"
        label="计划启停"
        width="80px"
      />
      <el-table-column
        prop="bstypeText"
        label="物料类型"
        width="80px"
      />
      <el-table-column
        prop="statusText"
        label="状态"
        width="80px"
      />
      <el-table-column
        prop="bid"
        label="出价"
        width="80px"
      />
      <el-table-column
        prop="bidtypeText"
        label="出价方式"
        width="80px"
      />
      <el-table-column
        prop="projectFeedId"
        label="智投项目id"
        width="80px"
      />
      <el-table-column
        prop="useLiftBudgetText"
        label="是否开启一键起量"
        width="80px"
      />
      <el-table-column
        prop="liftBudget"
        label="起量预算"
        width="80px"
      />
      <el-table-column
        prop="liftStatusText"
        label="起量状态"
        width="80px"
      />
      <el-table-column
        prop="starttimeText"
        label="推广开始时间"
        width="180px"
      />
      <el-table-column
        prop="endtimeText"
        label="推广结束时间"
        width="180px"
      />
      <el-table-column
        prop="addtimeText"
        label="添加时间"
        width="180px"
      />
      <el-table-column
        fixed="right"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="handleClick(scope.row)">复制</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible.sync="sync_campaign_feed"
      :destroy-on-close="true"
      title="选择账号"
      width="70%"
    >
      <sub-account @close="closeSCF()" @commit="CampaignFeed" />
    </el-dialog>
    <el-dialog
      :visible.sync="sync_copy"
      title="复制广告"
      width="98%"
      style="height: 90%"
    >
      <baiDuAuthAccount @close="sync_copy = false" @jobCreated="jobCreated" />
    </el-dialog>
    <el-drawer
      title="详细信息"
      :visible.sync="isDialogVisible"
      direction="rtl"
      size="50%"
    >
      <ocpc-info-table ref="ocpcInfo" :ocpc_info="ocpc_info" />
    </el-drawer>
    <el-drawer
      title="详细信息"
      :visible.sync="appInfoDialogVisible"
      direction="rtl"
      size="50%"
    >
      <appInfo ref="appInfo" :app_info="app_info" />
    </el-drawer>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>

import { accountSync, getBaiduADList, job_create } from '@/api/baiduAD'
import PaginationRight from '@/components/PaginationRight/index.vue'
import SubAccount from '@/views/baiduAD/components/subAccount.vue'
import BaiDuAuthAccount from '@/views/baiduAD/Plan/components/baiDuAuthAccount.vue'
import OcpcInfoTable from '@/views/baiduAD/components/ocpcInfoTable.vue'
import AppInfo from '@/views/baiduAD/components/appInfo.vue'

export default {
  components: { AppInfo, OcpcInfoTable, BaiDuAuthAccount, SubAccount, PaginationRight },
  data() {
    return {
      baidudataList: [],
      total: 50,
      page: 1,
      query: {
        campaignFeedId: '',
        campaignFeedName: '',
        page: 1,
        page_size: 10
      },
      sync_campaign_feed: false,
      campaignFeedId: null,
      sync_copy: false,
      account_list: [],
      commit_campaignFeedId: null,
      commit_sub_uc_id: null,
      isDialogVisible: false,
      ocpc_info: null,
      appInfoDialogVisible: false,
      app_info: []
    }
  },
  created() {
    this.list()
  },
  methods: {
    list() {
      getBaiduADList(this.query).then(res => {
        this.baidudataList = res.data.list
        this.total = res.data.total
      })
    },
    syncCampaignFeed() {
      this.sync_campaign_feed = true
    },
    closeSCF() {
      this.sync_campaign_feed = false
    },
    CampaignFeed(val) {
      accountSync({
        sub_uc_ids: val.map(res => res.sub_uc_id)
      }).then(res => {
        this.$message({
          type: 'success',
          message: '发送请求成功,请稍后刷新查看结果'
        })
        this.sync_campaign_feed = false
      })
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    search() {
      this.list()
    },
    handleClick(val) {
      this.sync_copy = true
      console.log('计划流id', val.campaignFeedId)
      console.log('子账号id', val.sub_uc_id)
      console.log(val)
      this.commit_campaignFeedId = val.campaignFeedId
      this.commit_sub_uc_id = val.sub_uc_id
    },
    jobCreated(val) {
      console.log(val)
      job_create({
        sub_uc_id: this.commit_sub_uc_id,
        campaign_ids: [this.commit_campaignFeedId],
        target_sub_uc_ids: val
      }).then(res => {
        console.log(res)
        this.$message.info(res.message)
        this.sync_copy = false
      })
    },
    openoCPC(row) {
      console.log(row)
      this.ocpc_info = row
      this.isDialogVisible = true // 显示抽屉
    },
    appInfoLook(val) {
      console.log('AppInfo信息', val)
      this.app_info = val
      this.appInfoDialogVisible = true
    }
  }
}
</script>

<style scoped>
.allbox {
  padding: 30px;
}
.tag_box{
  margin: 0 10px 10px 0px;
}
.inptw {
  width: 250px;
}
.condition >* {
  margin-right: 10px;
}
</style>
